import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';


export class ScreenTalentService {

	public emitEventActionSource = new Subject <any>();

	public emitEventAction$ = this.emitEventActionSource.asObservable();

	public emitEventAction(dataToEmit: any): void {
		this.emitEventActionSource.next(dataToEmit);
	}
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/screen-talent/screen-talent.service.ts